"use client"

import { ReactNode } from "react"
import { usePathname } from "next/navigation"
import { useMe } from "@/hooks/use-me"
import AppSidebar from "@/components/layout/AppSidebar"

export default function AuthShell({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const { data: me } = useMe()

  const isAuthPage = pathname === "/sign-in" || pathname === "/login" || pathname === "/activate" || pathname === "/reset-password"
  const isTwoFASetup = pathname === "/enable-2fa"
  const isAuthed = !!me
  const noChrome = typeof document !== 'undefined' && document.body.classList.contains('no-chrome')

  // Hide chrome on sign-in route or when not authenticated
  if (isAuthPage || isTwoFASetup || !isAuthed || noChrome) {
    return <>{children}</>
  }

  return (
    <div className="flex min-h-dvh bg-[#0F172A]">
      <AppSidebar />
      <div className="flex-1 min-w-0 flex bg-background">
        <div className="flex-1 min-w-0 bg-background">
          {children}
        </div>
      </div>
    </div>
  )
}
